var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.646 10.862 2.146-1.898.248-5.488L16.646 1l-1.65.206-.62 1.445-1.485 5.695 2.601 2.311 1.156.206zm4.375 2.641h-9.986L6 15.98v6.354l2.517 2.476 2.971-2.476v3.755L15.904 31l4.456-4.91v-3.756l3.054 2.476 2.517-2.723v-6.108l-4.91-2.477zm-5.075 2.559c1.664 0 3.012-.314 3.012-.702 0-.387-1.348-.701-3.012-.701-1.664-.001-3.012.313-3.012.7 0 .388 1.348.702 3.012.702z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMix);
export default __webpack_public_path__ + "static/media/MIX.0d95aa1f4e6a1786626458c89fd57261.svg";
export { ForwardRef as ReactComponent };